var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfieCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 6.9811C1.6665 6.68917 1.6665 6.5432 1.67869 6.42026C1.79617 5.23447 2.73423 4.29642 3.92001 4.17893C4.04296 4.16675 4.1968 4.16675 4.50449 4.16675C4.62305 4.16675 4.68233 4.16675 4.73266 4.1637C5.37535 4.12478 5.93813 3.71915 6.17829 3.12175C6.1971 3.07496 6.21468 3.02222 6.24984 2.91675C6.285 2.81127 6.30258 2.75853 6.32138 2.71175C6.56154 2.11435 7.12433 1.70872 7.76702 1.6698C7.81735 1.66675 7.87294 1.66675 7.98412 1.66675H12.0156C12.1267 1.66675 12.1823 1.66675 12.2327 1.6698C12.8753 1.70872 13.4381 2.11435 13.6783 2.71175C13.6971 2.75853 13.7147 2.81127 13.7498 2.91675C13.785 3.02222 13.8026 3.07496 13.8214 3.12175C14.0615 3.71915 14.6243 4.12478 15.267 4.1637C15.3173 4.16675 15.3766 4.16675 15.4952 4.16675C15.8029 4.16675 15.9567 4.16675 16.0797 4.17893C17.2654 4.29642 18.2035 5.23447 18.321 6.42026C18.3332 6.5432 18.3332 6.68917 18.3332 6.9811V13.5001C18.3332 14.9002 18.3332 15.6003 18.0607 16.1351C17.821 16.6055 17.4386 16.9879 16.9681 17.2276C16.4334 17.5001 15.7333 17.5001 14.3332 17.5001H5.6665C4.26637 17.5001 3.56631 17.5001 3.03153 17.2276C2.56112 16.9879 2.17867 16.6055 1.93899 16.1351C1.6665 15.6003 1.6665 14.9002 1.6665 13.5001V6.9811Z",
    stroke: "#51525C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 13.7501C11.8408 13.7501 13.3332 12.2577 13.3332 10.4167C13.3332 8.5758 11.8408 7.08341 9.99984 7.08341C8.15889 7.08341 6.6665 8.5758 6.6665 10.4167C6.6665 12.2577 8.15889 13.7501 9.99984 13.7501Z",
    stroke: "#51525C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfieCamera);
export default __webpack_public_path__ + "static/media/selfie-camera.ac7f7a4487a8753bd4a32642028f9032.svg";
export { ForwardRef as ReactComponent };